import { AuthenticatedApiClient } from '@guiker/payout-shared'
import { useAuthenticatedApiClient } from '@guiker/react-framework'

export const useAuthenticatedPayoutApiClient = useAuthenticatedApiClient(AuthenticatedApiClient)
